import { useRouter } from '@tanstack/react-router';
import type { AnchorHTMLAttributes, MouseEvent } from 'react';

/**
 * An in-app link to a path known only at runtime (backend navigation, a guard's target). A real
 * `<a href>`, so it can be opened in a new tab; a plain left click navigates through the router.
 * TanStack's typed `<Link to>` cannot take these paths, and a package cannot know an app's route
 * tree anyway.
 */
export function AppLink({
  href,
  onClick,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const router = useRouter();
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    event.preventDefault();
    void router.navigate({ href });
  };
  return <a href={href} onClick={handleClick} {...rest} />;
}
